module.exports = __webpack_public_path__ + "img/lock-success.f6ec87d6.svg";